"use client";
import React, { useState } from "react";
import style from "./page.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useRouter } from "next/navigation";
import { useDispatch } from "react-redux";
import { setLoading } from "./store/slice/slice";
import { signIn, useSession } from "next-auth/react";
import Loading from "./Components/Loading/Loading.component";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const router = useRouter();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [error, setError] = useState("");
  const {data:session,status} = useSession();
  const dispatch = useDispatch();
  if(session?.user){
    dispatch(setLoading({visible:true,message:'Navigating to admin page'}));
    router.push('/admin');
  }
  const [isAdminUsernameVerified, setAdminUsernameVerified] = useState(false);
  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setError("");
    setAdminUsernameVerified(false);
    setEmail(event.currentTarget.value);
  };
  const handleOtpChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const index: string =
      event.currentTarget.getAttribute("data-index") || "-1";
    if (parseInt(index) > -1) {
      const newOtp = [...otp];
      newOtp[parseInt(index)] = event.currentTarget.value;
      setOtp(newOtp);
    }
  };
  const checkAdminId = async (e: React.MouseEvent<HTMLButtonElement>) => {
    dispatch(setLoading({ visible: true, message: "Logging in ..." }));
    e.preventDefault();
    const response = await fetch(`/api//admin?username=${email}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const data = await response.json();
    if (data.success) {
      setAdminUsernameVerified(true);
    } else {
      setError(data.message);
      setAdminUsernameVerified(false);
    }
    dispatch(setLoading({ visible: false, message: "" }));
  };
  const handleLogin = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    try {
      dispatch(setLoading({ visible: true, message: "Verifying" }));
      const result = await signIn("credentials", {
        redirect: false,
        username: email,
        otp: otp.join(""),
      });
      if (result?.error) {
        alert(result?.error);
      }
      router.push("/admin");
      dispatch(setLoading({ visible: false, message: "" }));
    } catch (e) {
      console.log(e);
      dispatch(setLoading({ visible: false, message: "" }));
    }
  };
  function moveFocus(event: React.ChangeEvent<HTMLInputElement>) {
    const nextInputId = event.currentTarget.getAttribute("data-nextid");
    if (event.target.value.length === 1 && nextInputId) {
      document.getElementById(nextInputId)?.focus();
    }
  }

  return (
    <div
      className={`${style.mainContainer} col-12 d-flex justify-content-center align-items-center`}
    >
      <Loading></Loading>
      <div className={`${style.loginContainer} col-4`}>
        <h1>Admin login</h1>
        <span className={`${error ? "d-flex" : "d-none"} error`}>{error}</span>
        <form id="loginForm">
          <div className={style.inputGroup}>
            <strong>Admin username</strong>
            <input
              type="text"
              placeholder="Enter /admin user"
              id="username"
              name="username"
              value={email}
              onChange={handleEmailChange}
              required
            ></input>
          </div>
          <div
            className={`${style.inputGroup} ${
              isAdminUsernameVerified ? "" : "d-none"
            } col-12`}
          >
             <strong>Authenticator OTP</strong>
            <div className={`${style.otpContainer} col-12 d-flex gap-1`}>
              <input
                type="text"
                maxLength={1}
                className={`${style.otpBox} col-2`}
                id="otp1"
                data-index={"1"}
                onChange={handleOtpChange}
                data-nextid="otp2"
                onInputCapture={moveFocus}
              />
              <input
                type="text"
                maxLength={1}
                className={`${style.otpBox} col-2`}
                id="otp2"
                data-nextid="otp3"
                data-index={"2"}
                onChange={handleOtpChange}
                onInputCapture={moveFocus}
              />
              <input
                type="text"
                maxLength={1}
                className={`${style.otpBox} col-2`}
                id="otp3"
                data-nextid="otp4"
                data-index={"3"}
                onChange={handleOtpChange}
                onInputCapture={moveFocus}
              />
              <input
                type="text"
                maxLength={1}
                className={`${style.otpBox} col-2`}
                id="otp4"
                data-nextid="otp5"
                data-index={"4"}
                onChange={handleOtpChange}
                onInputCapture={moveFocus}
              />
              <input
                type="text"
                maxLength={1}
                className={`${style.otpBox} col-2`}
                id="otp5"
                data-nextid="otp6"
                data-index={"5"}
                onChange={handleOtpChange}
                onInputCapture={moveFocus}
              />
              <input
                type="text"
                maxLength={1}
                className={`${style.otpBox} col-2`}
                id="otp6"
                data-nextid=""
                data-index={"6"}
                onChange={handleOtpChange}
                onInputCapture={moveFocus}
              />
            </div>
          </div>
          <button
            onClick={isAdminUsernameVerified ? handleLogin : checkAdminId}
          >
            {isAdminUsernameVerified ? "Verify" : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
